import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclamation-circle",
  "use": "exclamation-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"exclamation-circle\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 5.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5ZM8 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z\" fill=\"#E66073\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol